import { useCallback } from 'react'

import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'
import { publisherWorkflowsT } from 'services/workflows/publisher_workflows_i18n'

/**
 * Rebrand-aware `publisher.workflows.*` translations for workflow modals (`useProductRefreshAppShell`).
 */
export function usePublisherWorkflowsModalT() {
  const isAppShellRebrand = useProductRefreshAppShell()
  return useCallback(
    (key, options) => publisherWorkflowsT(key, isAppShellRebrand, options),
    [isAppShellRebrand]
  )
}
